import React from 'react';
import PropTypes from 'prop-types';

import BWModal from '../BWModal';

const BWDetailModal = ({ closeLabel = 'Đóng', onClose, children, ...modalProps }) => (
  <BWModal {...modalProps} onClose={onClose} cancelAction={{ label: closeLabel }}>
    {children}
  </BWModal>
);

BWDetailModal.propTypes = {
  closeLabel: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default BWDetailModal;
